import { css } from '@emotion/css';
import { appColors, breakpoints, fontFamily } from '../styles/variables.style';

export const title = css`
  font-family: ${fontFamily.fredoka};
  color: ${appColors.gray200};
  margin: 0 0 20px;
  text-align: center;
  font-size: 30px;

  span {
    font-size: 36px;
    color: ${appColors.orange};
  }
`;

export const img = css`
  display: block;
  max-width: 100%;
  width: 180px;
  height: 180px;
  object-fit: contain;
  margin: 0 auto 30px;
`;



export const indicator = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  div {
    width: 10px;
    height: 10px;
    background-color: ${appColors.gray200};
    margin: 0 2px;
    border-radius: 50%;

    &.active {
      background-color: ${appColors.orange};
    }
  }
`;

export const questions = css`
  font-size: 12px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 1880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 29px;
  }
`;

export const note = css`
  font-size: 4px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 1880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 15px;
  }
`;


export const meanings = css`
  font-size: 12px;
  text-align: center;
  color: ${appColors.gray800};
  font-family: ${fontFamily.fredoka};
  margin: 0 auto 30px;
  max-width: 880px;

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 22px;
  }
`;


export const input = css`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 525px;
  height: 53px;
  background: ${appColors.white};
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 0 40px 0 10px;

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 0 36px;
    height: 63px;
  }
`;

export const answers = css`
  background: ${appColors.orange};
  padding: 10px;
  border-radius: 10px 10px 0 0;
  position: relative;
  min-height: 100px;
  padding-bottom: 20px;

  @media (min-width: ${breakpoints.lg.up}) {
    padding: 20px;
  }

  .s-title {
    text-align: center;
    font-size: 34px;
    color: ${appColors.white};
    font-family: ${fontFamily.fredoka};
    margin: 0 0 10px;

    @media (min-width: ${breakpoints.lg.up}) {
      font-size: 30px;
    }
  }
`;





export const iconGroup = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  img {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    display: block;
  }

  img:hover {
    cursor: pointer;
  }
`;

export const imgPoster = css`
  display: block;
  margin: 0 auto 20px;
  width: auto;
  max-width: 100%;
  height: 300px;
  object-fit: contain;
`;

export const keyboardButtonContainer = css`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`;

export const keyboardButton = css`
  background: transparent;
  border: none;
  color: ${appColors.gray800};
  cursor: pointer;
  font-size: 20px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.2s;
  z-index: 20;
  position: relative;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 24px;
  }
`;

export const keyboardContainer = css`
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 5px;
  background: ${appColors.white};
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  z-index: 1000;
  overflow: visible;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: ${appColors.white} transparent transparent transparent;
  }
`;

export const keyboardInner = css`
  max-height: 200px;
  overflow-y: auto;
  padding: 5px;
`;

export const keyboardRow = css`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  flex-wrap: nowrap;
  min-width: min-content;
`;

export const charButton = css`
  background: ${appColors.white};
  border: 1px solid ${appColors.gray200};
  border-radius: 4px;
  color: ${appColors.gray800};
  cursor: pointer;
  font-size: 16px;
  margin: 2px;
  padding: 8px 12px;
  min-width: 40px;
  text-align: center;
  transition: all 0.15s ease;
  flex-shrink: 0;
  user-select: none;
  touch-action: manipulation;
  position: relative;
  z-index: 10;

  &:active {
    transform: translateY(1px);
  }

  &:hover {
    background: ${appColors.orange};
    color: white;
    border-color: ${appColors.orange};
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }

  @media (min-width: ${breakpoints.lg.up}) {
    font-size: 18px;
    padding: 10px 15px;
    min-width: 50px;
  }
`;

export const keyboardClose = css`
  margin-top: 10px;
  text-align: center;
  padding-top: 10px;
  border-top: 1px solid ${appColors.gray200};
`;

export const closeButton = css`
  background: ${appColors.gray200};
  color: ${appColors.gray800};
  border: none;
  border-radius: 4px;
  padding: 5px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  
  &:hover {
    background: ${appColors.gray300};
  }
`;
